import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData, getVideoGallery} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import VideoSection from './components/videoCollage'


const VideoGallery = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [videoGalleryData, setvideoGalleryData] = useState(null);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        const videoGalleryData = await getVideoGallery();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        setvideoGalleryData(videoGalleryData)
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Helmet>
      <title>Things to do in nathdwara | biggest shiva statue in rajasthan</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Video Gallery</li>
        </ul>
        <h1>Video Gallery</h1>
      </Container>
    </section>
    <section className='video_section'>
      <Container>
        <VideoSection isDesktop={false} compData={videoGalleryData} />
      </Container>
    </section>
    <Faqs compData={faQSlice.slice(0,5)} />
    <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
    <Footer />
    </div>
  );
};

export default VideoGallery;